// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x8qv","rootNoMargin":"styles_rootNoMargin__YdjL4"};